<template>
  <v-container fluid class="px-0">
    <v-card outlined class="my-0">
      <v-card-title style="padding: 0.5rem 1rem">
        <v-row @click="setExpanded" style="cursor: pointer" no-gutters>
          <v-col cols="4"
            ><v-icon>{{
              isExpanded ? 'mdi-chevron-up' : 'mdi-chevron-down'
            }}</v-icon>
            {{ $t('Filtras') }}</v-col
          >
        </v-row>
      </v-card-title>
      <v-expand-transition>
        <v-card-text class="pt-1" v-if="isExpanded">
          <form @keydown.enter.prevent="submit()">
            <v-row class="mb-0 pb-0">
              <v-col cols="12" md="6" lg="3">
                <el-text-field
                  label="Paieškos Nr."
                  tooltip="'Ireg. Pagrindinis. Paieška. Paieškų sąrašas. Paieškos nr"
                  v-model="mainData['number-search-custom']"
                  hide-details
                  :maxlength="1000"
                />
              </v-col>
              <v-col cols="12" md="6" lg="3">
                <el-autocomplete
                  :items="enumsClassifiers.searchListStatus"
                  enums
                  hide-details
                  itemvalue="value"
                  itemtext="text"
                  label="Būsena"
                  tooltip="Ireg. Pagrindinis. Paieška. Paieškų sąrašas. Būsena"
                  v-model="mainData['status-search-custom']"
                />
              </v-col>
              <v-col cols="12" md="12" lg="6">
                <el-autocomplete
                  :items="enumsClassifiers.dataVolumeOrderIreg"
                  enums
                  hide-details
                  itemvalue="value"
                  itemtext="text"
                  label="Paieškos tipas"
                  tooltip="Ireg. Pagrindinis. Paieška. Paieškų sąrašas. Paieškos tipas"
                  v-model="mainData['type-search-like']"
                />
              </v-col>
              <v-col cols="12" md="6" lg="3">
                <el-text-field
                  label="Naudotojas"
                  tooltip="'Ireg. Pagrindinis. Paieška. Paieškų sąrašas. Naudotojas"
                  v-model="mainData['search_by-search-custom']"
                  hide-details
                  :maxlength="1000"
                />
              </v-col>
              <v-col  class="pb-0" cols="12" md="6" lg="3">
                <el-date-picker
                  :beforeDates="mainData['created_at-search-to']"
                  label="Paieškos suformavimo data nuo"
                  tooltip="Ireg. Pagrindinis. Paieška. Paieškų sąrašas. Paieškos suformavimo data nuo"
                  v-model="mainData['created_at-search-from']"
                />
              </v-col>
              <v-col  class="pb-0" cols="12" md="6" lg="3">
                <el-date-picker
                  :afterDates="mainData['created_at-search-from']"
                  label="Paieškos suformavimo data iki"
                  tooltip="Ireg. Pagrindinis. Paieška. Paieškų sąrašas. Paieškos suformavimo data iki"
                  v-model="mainData['created_at-search-to']"
                />
              </v-col>
              <v-col cols="12" md="6" lg="3">
                <el-text-field
                  label="Duomenų gavėjas"
                  tooltip="'Ireg. Pagrindinis. Paieška. Paieškų sąrašas. Duomenų gavėjas"
                  v-model="mainData['customer_fullname-search-like']"
                  hide-details
                  :maxlength="200"
                />
              </v-col>

              <v-col cols="12" md="6" lg="3">
                <el-text-field
                  label="Duomenų gavėjo asmens kodas"
                  tooltip="'Ireg. Pagrindinis. Paieška. Paieškų sąrašas. Duomenų gavėjo asmens kodas"
                  v-model="mainData['customer_code-search-like']"
                  hide-details
                  :cMask="11"
                  :maxlength="11"
                />
              </v-col>
              <v-col cols="12" md="6" lg="3">
                <el-text-field
                  label="Duomenų gavėjo ILTU kodas"
                  tooltip="'Ireg. Pagrindinis. Paieška. Paieškų sąrašas. Duomenų gavėjo iltu kodas"
                  v-model="mainData['customer_iltu_code-search-like']"
                  hide-details
                  :cMask="11"
                  :maxlength="11"
                />
              </v-col>
              <v-col cols="12" md="6" lg="3">
                <el-text-field
                  label="Duomenų gavėjo juridinio asmens kodas"
                  tooltip="'Ireg. Pagrindinis. Paieška. Paieškų sąrašas. Duomenų gavėjo juridinio asmens kodas"
                  v-model="mainData['customer_jur_code-search-like']"
                  hide-details
                  :cMask="11"
                  :maxlength="11"
                />
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col cols="12">
                <el-button
                  class="mr-1"
                  title="Ieškoti"
                  :loading="loading"
                  color="primary"
                  icon="ieškoti"
                  @click.native.stop="beforeSearch()"
                />
                <el-report-btn object="statement-orders" :loading="loading" :reportData="reportData" :listURL="'my-list'" />
                <el-button
                  color="secondary"
                  icon="išvalyti"
                  title="Išvalyti"
                  :loading="loading"
                  @click.native="clearData()"
                />
              </v-col>
            </v-row>
          </form>
        </v-card-text>
      </v-expand-transition>
    </v-card>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import Enums from '@/enums'

export default {
  name: 'AdminSearchListSearch',
  props: {
    loading: Boolean,
  },
  data: () => ({
    mainData: {},
    reportData: {},
    enumsClassifiers: [],
  }),
  computed: {
    ...mapGetters(['searchParams']),
    isExpanded() {
      if (this.mainData.isExpanded == null) {
        this.$set(this.mainData, 'isExpanded', false)
      }
      return this.mainData.isExpanded
    },
  },
  inject: {
    $validator: '$validator',
  },
  created() {
    this.getClassifiers()
    this.searchData()
  },
  methods: {
    downloadReport() {
      this.$emit('downloadReport')
    },
    setExpanded() {
      let logic = !this.mainData.isExpanded
      this.$set(this.mainData, 'isExpanded', logic)
    },
    getClassifiers() {
      this.enumsClassifiers = Enums
      if (this.searchParams && this.searchParams.route === this.$route.name) {
        this.mainData = this.searchParams.mainData
      }
    },
    searchData(button) {
      let searchData = { ...this.mainData }
      this.$store.dispatch('searchParams', {
        route: this.$route.name,
        mainData: this.mainData,
      })
      searchData.btn = button
      this.reportData = { ...this.mainData }
      this.$emit('search', searchData)
    },
    clearData() {
      this.mainData = {isExpanded: true, clear: true }
      this.$nextTick(() => {
        this.mainData = { isExpanded: true }
        this.searchData(true)
      })
    },
    submit() {
      this.beforeSearch()
    },
    beforeSearch() {
      this.$validator.validateAll().then((res) => {
        if (res) {
            this.searchData(true)
        } 
      })
    },
  },
}
</script>
